import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import RecentLooks from "@/components/RecentLooks";
import DesignersMarquee from "@/components/DesignersMarquee";
import Testimonials from "@/components/Testimonials";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";

function App() {
  const [ready, setReady] = useState(false);

  // Intro splash holds for 3 seconds before the site opens
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 3000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [ready]);

  if (!ready) {
    return (
      <div className="min-h-screen bg-linen flex items-center justify-center" data-testid="site-loading">
        <p className="font-serif text-2xl tracking-[0.15em] uppercase text-ink animate-pulse">Vrisha Muni</p>
      </div>
    );
  }

  return (
    <div className="App bg-linen text-ink font-sans">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <RecentLooks />
        <DesignersMarquee />
        <Testimonials />
        <EnquiryForm />
      </main>
      <Footer />
      <Toaster position="bottom-center" toastOptions={{ style: { background: '#1A1714', color: '#FBF9F5', border: '1px solid rgba(197,155,39,0.4)' } }} />
    </div>
  );
}

export default App;
